import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { logout } from '../../Stores/Action/AuthAction';
import { modena_logo_putih } from '../../Images';
import { elipse_user } from '../../Images';
import { useNavigate } from 'react-router-dom';
import { InputSwitch } from 'primereact/inputswitch';
import { toggleMode } from "../../Stores/Action/ThemeAction";

const { $ } = window;

const Sidebar = () => {
    const navigate = useNavigate();
    let { userInfo } = useSelector(state => state.auth);

    if (!userInfo) {
        userInfo = {}
    }

    const dispatch = useDispatch();

    const signOut = () => {
        dispatch(logout(navigate));
    }

    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <ul className="list-group" id="menu">
                    <li className="list-group-item">
                        <NavLink to="/" className="nav-link px-0 align-middle menu-item">Home</NavLink>
                    </li>
                    <li className="list-group-item">
                        <NavLink to="/setting/menu" className="nav-link px-0 align-middle menu-item">Menu</NavLink>
                    </li>
                    {/* <li className="list-group-item">
                        <NavLink to="/setting/category" className="nav-link px-0 align-middle menu-item">Asset Category</NavLink>
                    </li> */}
                    <li className="list-group-item">
                        <NavLink to="/setting/type" className="nav-link px-0 align-middle menu-item">Asset Type</NavLink>
                    </li>
                    <li className="list-group-item">
                        <NavLink to="/setting/filter" className="nav-link px-0 align-middle menu-item">Asset Filter</NavLink>
                    </li>
                    <li className="list-group-item">
                        <NavLink to="/setting/log" className="nav-link px-0 align-middle menu-item">Asset Log</NavLink>
                    </li>
                    {/* <li className="list-group-item">
                        <NavLink to="/setting/thumbnail" className="nav-link px-0 align-middle menu-item">Thumbnail</NavLink>
                    </li> */}
                    <li className="list-group-item">
                        <NavLink to="/setting/meta" className="nav-link px-0 align-middle menu-item">Meta</NavLink>
                    </li>
                    <li className="list-group-item">
                        <NavLink to="/setting/limit" className="nav-link px-0 align-middle menu-item">Storage Limit</NavLink>
                    </li>
                    <li className="list-group-item">
                        <NavLink to="/setting/user" className="nav-link px-0 align-middle menu-item">User</NavLink>
                    </li>
                    <li className="list-group-item">
                        <NavLink to="/setting/role" className="nav-link px-0 align-middle menu-item">Role</NavLink>
                    </li>
                </ul>
            </div>
        </div>

    )
}

export default Sidebar;